// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.welcome-text-container {
  color: #0669B3;
}
.welcome-text-container .accordion {
  margin-bottom: 20px;
}
.welcome-text-container .accordion-header .accordion-button {
  background-color: #EDf0F1;
}
.welcome-text-container .accordion-header h5 {
  color: #0669B3;
  font-size: 1.1rem;
  font-weight: 700;
}
.welcome-text-container .accordion-body {
  background-color: #EDf0F1;
  color: #0669B3;
}
.welcome-text-container .accordion-body p {
  font-size: 1rem;
  line-height: 1.1rem;
}
.welcome-text-container .accordion-body ul {
  margin-top: 10px;
}
.welcome-text-container .accordion-body ul > li {
  font-size: 1rem;
  line-height: 1.7rem;
}
.welcome-text-container .accordion-body ul.charter-school-li > li {
  font-weight: 550;
}
.welcome-text-container a {
  color: #0669B3;
  font-weight: 500;
}
.welcome-text-container h4 {
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.1rem;
}
.welcome-text-container h5 {
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.1rem;
}
.welcome-text-container p {
  font-weight: 500;
  line-height: 1.75rem;
}
.welcome-text-container span.highlight {
  background-color: #FEBF31;
  color: #444343;
  font-weight: 500;
  padding: 0 3px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/WelcomeText.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,cD4BS;AClBb;AATI;EACI,mBAAA;AAWR;AARQ;EACI,yBDcJ;ACJR;AARQ;EACI,cDmBC;EClBD,iBAAA;EACA,gBAAA;AAUZ;AAPI;EACI,yBDKA;ECJA,cDYK;ACHb;AARQ;EACI,eAAA;EACA,mBAAA;AAUZ;AARQ;EACI,gBAAA;AAUZ;AARQ;EACI,eAAA;EACA,mBAAA;AAUZ;AARQ;EACI,gBAAA;AAUZ;AAPI;EACI,cDLK;ECML,gBAAA;AASR;AAPI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AASR;AAPI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AASR;AAPI;EACI,gBAAA;EACA,oBAAA;AASR;AAPI;EACI,yBDhCI;ECiCJ,cD1BC;EC2BD,gBAAA;EACA,cAAA;AASR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Guardian Dashboard colors\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n\n$error: #CE3525;\n$error-dk: #aa3333;\n$error-hover: #cf4635;\n$hover-white: #E0E0E0;\n$light-background: #EFEFEF;\n\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #4a8319;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$icon-blue: #4DD9FF;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/GlobalMixins\";\n\n.welcome-text-container {\n    color: $pearl-blue;\n    .accordion {\n        margin-bottom: 20px;\n    }\n    .accordion-header {\n        .accordion-button {\n            background-color: $grey0;\n        }\n        & h5 {\n            color: $pearl-blue;\n            font-size: 1.1rem;\n            font-weight: 700;\n        }\n    }\n    .accordion-body {\n        background-color: $grey0;\n        color: $pearl-blue;\n        & p {\n            font-size: 1.0rem;\n            line-height: 1.1rem;\n        }\n        & ul {\n            margin-top: 10px;\n        }\n        & ul>li {\n            font-size: 1.0rem;\n            line-height: 1.7rem;\n        }\n        & ul.charter-school-li>li {\n            font-weight: 550;\n        }\n    }\n    & a {\n        color: $pearl-blue;\n        font-weight: 500;\n    }\n    & h4 {\n        font-size: 1.2rem;\n        font-weight: 700;\n        line-height: 1.1rem;\n    }\n    & h5 {\n        font-size: 1.1rem;\n        font-weight: 700;\n        line-height: 1.1rem;\n    }\n    & p {\n        font-weight: 500;\n        line-height: 1.75rem;\n    }\n    & span.highlight {\n        background-color: $important;\n        color: $grey4a;\n        font-weight: 500;\n        padding: 0 3px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
